// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Intro_content__zmWMR {
  text-align: center;
}
.Intro_content__zmWMR p {
  font-size: 15.6px;
}
.Intro_content__zmWMR button {
  float: none;
}

.Intro_popup__yNtFZ {
  width: 430px;
  max-width: 90vw;
  position: absolute;
  z-index: 2;
  top: 50vh;
  left: 50vw;
  transform: translate(-50%, -50%);
  background: #FFF;
  border-radius: 12px;
  padding: 32px;
  text-align: center;
}
.Intro_popup__yNtFZ button {
  width: 100%;
  margin: 0;
  float: none;
  border: 1px solid #1414ff;
  border-radius: 8px;
}
.Intro_popup__yNtFZ button:first-of-type {
  color: #FFF;
  background-color: #1414ff;
  margin-top: 27px;
}
.Intro_popup__yNtFZ button:last-of-type {
  color: #1414ff;
  background-color: #FFF;
  margin-top: 12px;
}

.Intro_loading__lJe0s {
  text-align: center;
}
.Intro_loading__lJe0s svg {
  width: 40px;
  animation-name: Intro_rotate__1rOAu;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
.Intro_loading__lJe0s svg circle {
  fill: #00007a;
}

@keyframes Intro_rotate__1rOAu {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/RCPro/pages/Intro/Intro.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAEA;EACI,kBAAA;AAKJ;AAHI;EACI,iBAAA;AAKR;AAFI;EACI,WAAA;AAIR;;AAAA;EACI,YAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,gCAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AAGJ;AADI;EACI,WAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AAGR;AADQ;EACI,WAAA;EACA,yBChCD;EDiCC,gBAAA;AAGZ;AADQ;EACI,cCpCD;EDqCC,sBAAA;EACA,gBAAA;AAGZ;;AAEA;EACI,kBAAA;AACJ;AACI;EACI,WAAA;EACA,mCAAA;EACA,sBAAA;EACA,mCAAA;EACA,iCAAA;AACR;AACQ;EACI,aCnDD;ADoDX;;AAIA;EACI;IAAM,uBAAA;EAAR;EACE;IAAI,yBAAA;EAEN;AACF","sourcesContent":["@use 'styles/colors.scss';\n\n.content{\n    text-align: center;\n\n    p{\n        font-size: 15.6px;\n    }\n\n    button{\n        float: none;\n    }\n}\n\n.popup{\n    width: 430px;\n    max-width: 90vw;\n    position: absolute;\n    z-index: 2;\n    top: 50vh;\n    left: 50vw;\n    transform: translate(-50%, -50%);\n    background: #FFF;\n    border-radius: 12px;\n    padding: 32px;\n    text-align: center;\n\n    button{\n        width: 100%;\n        margin: 0;\n        float: none;\n        border: 1px solid colors.$primary5;\n        border-radius: 8px;\n\n        &:first-of-type{\n            color: #FFF;\n            background-color: colors.$primary5;\n            margin-top: 27px;\n        }\n        &:last-of-type{\n            color: colors.$primary5;\n            background-color: #FFF;\n            margin-top: 12px;\n        }\n    }\n}\n\n.loading{\n    text-align: center;\n\n    svg{\n        width: 40px;\n        animation-name: rotate;\n        animation-duration:2s;\n        animation-iteration-count:infinite;\n        animation-timing-function:linear;\n\n        circle{\n            fill: colors.$primary8;\n        }\n    }\n}\n\n@keyframes rotate {\n    from{ transform:rotate(0deg); }\n    to{ transform:rotate(360deg); }\n}","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"content": `Intro_content__zmWMR`,
	"popup": `Intro_popup__yNtFZ`,
	"loading": `Intro_loading__lJe0s`,
	"rotate": `Intro_rotate__1rOAu`
};
export default ___CSS_LOADER_EXPORT___;
